import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { animateBackdrop } from '@tesla/design-system';
import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
/**
 * SiteNavItems
 * @deprecated - Re-named NavItemGroup, will be deleted in a future major version
 */

export var SiteNavItems = function SiteNavItems(_ref) {
  var _cx;

  var align = _ref.align,
      animated = _ref.animated,
      children = _ref.children,
      className = _ref.className,
      layout = _ref.layout,
      rest = _objectWithoutProperties(_ref, ["align", "animated", "children", "className", "layout"]);

  var listRef = useRef(null);
  useEffect(function () {
    if (listRef && listRef.current && animated) {
      animateBackdrop(listRef.current);
    }
  }, [children, animated]);
  return React.createElement("ol", _objectSpread({
    className: cx('tds-site-nav-items', (_cx = {}, _defineProperty(_cx, "tds-align--".concat(align), align), _defineProperty(_cx, "tds-site-nav-items--".concat(layout), layout), _cx), className),
    ref: listRef
  }, rest), animated && React.createElement("div", {
    className: "tds-animate--backdrop-backdrop"
  }), React.Children.map(children, function (child) {
    return child && React.createElement("li", null, child);
  }));
};